import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@autoinject
export class Service {
  public servicesMenu: Array<{ route: string; name: string }> = [
    { route: 'radio-advertising', name: 'Radio Advertising' },
    { route: 'digital-marketing', name: 'Digital Marketing' },
    { route: 'television-advertising', name: 'Television Advertising' },
    { route: 'influencers', name: 'Influencers' },
    { route: 'conceptualization', name: 'Conceptualization' },
    { route: 'podcasts', name: 'Podcasts' },
    { route: 'production', name: 'Production' },
    { route: 'public-relations', name: 'Public Relations' },
    { route: 'activations', name: 'Activations' },
    { route: 'workshops-training', name: 'Workshops & Training' },
    { route: 'social-media', name: 'Social Media' },
    { route: 'research', name: 'Research' },
    { route: 'web-development', name: 'Web Development' }
  ];

  constructor(private router: Router) {
    console.log(' ::>> service loaded ', router);
  }

  public routeTo(route: { route: string }): void {
    console.log(' ::>> route >>>> ', route, this);
    this.router.navigate(route.route);
  }
}
